import { render, staticRenderFns } from "./RecipelRecord.vue?vue&type=template&id=0d3ee877&scoped=true"
import script from "./RecipelRecord.vue?vue&type=script&lang=ts"
export * from "./RecipelRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3ee877",
  null
  
)

export default component.exports